var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnTypeEyelet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#292929",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 3.745C14.626 3.745 3.745 14.625 3.745 28c0 13.374 10.88 24.255 24.255 24.255 13.374 0 24.255-10.88 24.255-24.255 0-13.374-10.88-24.255-24.255-24.255M28 54C13.663 54 2 42.336 2 28S13.663 2 28 2s26 11.664 26 26-11.663 26-26 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 45.45c-9.622 0-17.45-7.828-17.45-17.45S18.378 10.55 28 10.55 45.45 18.378 45.45 28a17.4 17.4 0 01-1.048 5.965 1.745 1.745 0 01-3.28-1.193c.556-1.527.838-3.133.838-4.772 0-7.697-6.263-13.96-13.96-13.96-7.697 0-13.96 6.263-13.96 13.96 0 7.697 6.263 13.96 13.96 13.96 1.785 0 3.529-.336 5.184-.999a1.744 1.744 0 111.297 3.24A17.373 17.373 0 0128 45.45"
  }))));
}
export default SvgIcnTypeEyelet;